import {useMutation} from 'react-query';
import {ISendMessagePayload} from '../../../models/payload/sendMessagePayload';
import {sendMessage} from '../../../services/message';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';

const useSendMessage = (
  reset: React.Dispatch<React.SetStateAction<string>>,
  refetch: () => void,
) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: ISendMessagePayload) => {
      return sendMessage(payload);
    },
    onSuccess: () => {
      reset('');
      refetch();
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export default useSendMessage;
